// extracted by mini-css-extract-plugin
export default {"noIssues":"ControllerIssues_noIssues__yy1Re","noIssuesIcon":"ControllerIssues_noIssuesIcon__qBx1Z"};